import React, { Fragment } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import About from '../About/About';
import HeroTextCarousel from './HeroTextCarousel';
import './HeroImage.scss';

export default function HeroImage(props) {
  const getHeroUrl = (providedUrl, isTerm, fallbackPath) => {
    if (isTerm) {
      return providedUrl ? providedUrl : fallbackPath;
    }
    return providedUrl;
  };

  const mobileUrl = getHeroUrl(props.heroImageMobileUrl, props.isTermInsurance, '/product-landing/term/term-hero-mobile.png');
  const tabletUrl = getHeroUrl(props.heroImageTabletUrl, props.isTermInsurance, '/product-landing/term/term-hero-image.png');
  const desktopUrl = getHeroUrl(props.heroImageUrl, props.isTermInsurance, '/product-landing/term/term-hero-image.png');

  const heroBridge = {
    '--hero-url-mobile': `url(${mobileUrl})`,
    '--hero-url-tablet': `url(${tabletUrl})`,
    '--hero-url-desktop': `url(${desktopUrl})`,
  };

  return (
    <div style={heroBridge}>
      {(!props.isTermInsurance && !props.isFinalExpense && !props.isWholeLife && !props.isUniversalLife && !props.isLoanProtection && !props.isBusinessSolutions) && <Term {...props} />}
      {props.isTermInsurance && <TermInsurance {...props} />}
      {props.isFinalExpense && <FinalExpense {...props} />}
      {props.isWholeLife && <WholeLife {...props} />}
      {props.isUniversalLife && <UniversalLife {...props} />}
      {props.isLoanProtection && <LoanProtection {...props} />}
      {props.isBusinessSolutions && <BusinessSolutions {...props} />}
    </div>
  );
}

export function Term(props) {
  const medicareNav = props.title === "Navigating Medicare" ? "medicare-subtitle" : "";

  return (
    <React.Fragment>
      <Row className={`landing-hero-image hero-image justify-content-center ${props.smallHero ? 'small-hero' : ''}`}>
        <div className={`px-0 background-image hero-image-container`}></div>
        <Container fluid className="content-section w-100">
          <Col md="auto">
            <Row className="d-flex align-items-center hero-content">
              <Col lg className="text-wrapper d-flex flex-column w-100">
                <Col lg className="text d-flex flex-column">
                  {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                  {!props.heroText &&
                    <Fragment>
                      <h1>{props.title}</h1>
                      <div className={medicareNav}>
                        <h2>{props.subtitle}</h2>
                        {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                      </div>
                    </Fragment>
                  }
                </Col>
              </Col>

              <Col lg="auto" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
            {props.about &&
              <Row>
                <About title={props.about.title} content={props.about.content} disclaimer={props.about.disclaimer} />
              </Row>
            }
          </Col>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function TermInsurance(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className={`content-section term-insurance ${props.isTermInsurance && props.isTestimonialPanelEnable ? 'custom-term-hero-img' : ''} m-0 w-100`} >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column hero-image-container`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form w-100 ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function FinalExpense(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0 w-100" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column hero-image-container`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form w-100 px-0 ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function WholeLife(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0 w-100" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column hero-image-container`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form w-100 px-0 ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function UniversalLife(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0 w-100" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column hero-image-container`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form w-100 px-0 ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function LoanProtection(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0 w-100" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column hero-image-container`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form w-100 px-0 ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function BusinessSolutions(props) {
  return (
    <React.Fragment>
      <Row className={"landing-hero-image hero-image justify-content-center tight-hero"}>
        <div className={`background-image hero-image-container px-0`}></div>
        <Container fluid className="content-section business-solutions w-100">
          <Col md="auto">
            <Row className="d-flex align-items-center hero-content">
              <Col lg className="text-wrapper d-flex flex-column w-100">
                <Col lg className="text d-flex flex-column text-carousel-wrapper">
                  {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                  {!props.heroText &&
                    <Fragment>
                      <h1>{props.title}</h1>
                      <div>
                        <h2>{props.subtitle}</h2>
                        {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                      </div>
                    </Fragment>
                  }
                </Col>
              </Col>
            </Row>
          </Col>
        </Container>
      </Row>
    </React.Fragment>
  );
}

HeroImage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  about: PropTypes.object,
  heroText: PropTypes.array,
  hasQuickQuoteDisclaimer: PropTypes.bool,
  smallHero: PropTypes.bool,
};
